<template>
<div>
  <div class="wistia_embed wistia_async_ojn9pwa0zr">
    &nbsp;
  </div>

  <div
    id="cost_of_care"
    class="tbk-vid-embed"
  >
    <a
      id="five_key_phrases"
      class="embedded_video"
      href="#wistia_urui50cqci?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="for_emergencies_only"
      class="embedded_video"
      href="#wistia_dlnkowclyf?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="bill_review"
      class="embedded_video"
      href="#wistia_6w67malshm?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('ojn', 28, this.showSelect)
    this.tbk.loadCrossTime('uru', 282, this.showSelect)
    this.tbk.loadCrossTime('dln', 125, this.showSelect)
    this.tbk.loadCrossTime('6w6', 111, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        uru: this.tbk.autoPlay,
        dln: this.tbk.autoPlay,
        '6w6': this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#cost_of_care
  display: none
  a
    text-decoration: none
#five_key_phrases
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (39 / 640))
  width: calc(100% * (160 / 640))
  height: calc(100% * (140 / 360))
#for_emergencies_only
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (239 / 640))
  width: calc(100% * (160 / 640))
  height: calc(100% * (140 / 360))
#bill_review
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (438 / 640))
  width: calc(100% * (160 / 640))
  height: calc(100% * (140 / 360))
</style>
